import { render, staticRenderFns } from "./RequestServiceResult.vue?vue&type=template&id=971faca4&scoped=true"
import script from "./RequestServiceResult.vue?vue&type=script&lang=js"
export * from "./RequestServiceResult.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceResult.vue?vue&type=style&index=0&id=971faca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971faca4",
  null
  
)

export default component.exports